function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  fill: "#343434",
  points: "127.9611 0 125.1661 9.5 125.1661 285.168 127.9611 287.958 255.9231 212.32"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#8C8C8C",
  points: "127.962 0 0 212.32 127.962 287.959 127.962 154.158"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#3C3C3B",
  points: "127.9611 312.1866 126.3861 314.1066 126.3861 412.3056 127.9611 416.9066 255.9991 236.5866"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#8C8C8C",
  points: "127.962 416.9052 127.962 312.1852 0 236.5852"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#141414",
  points: "127.9611 287.9577 255.9211 212.3207 127.9611 154.1587"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#393939",
  points: "0.0009 212.3208 127.9609 287.9578 127.9609 154.1588"
}));

function SvgIconEthereumColour(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "417px",
    viewBox: "0 0 256 417",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEthereumColour);
export default __webpack_public_path__ + "static/media/icon-ethereum-colour.761723a2.svg";
export { ForwardRef as ReactComponent };